import { render, staticRenderFns } from "./BulkAdd.vue?vue&type=template&id=0fb481ab&scoped=true&"
import script from "./BulkAdd.vue?vue&type=script&lang=js&"
export * from "./BulkAdd.vue?vue&type=script&lang=js&"
import style0 from "./BulkAdd.vue?vue&type=style&index=0&id=0fb481ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb481ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fb481ab')) {
      api.createRecord('0fb481ab', component.options)
    } else {
      api.reload('0fb481ab', component.options)
    }
    module.hot.accept("./BulkAdd.vue?vue&type=template&id=0fb481ab&scoped=true&", function () {
      api.rerender('0fb481ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ecoupon/peddler-management/components/BulkAdd.vue"
export default component.exports